export default __webpack_public_path__ + "static/media/exel.c11e6924.svg";